const GET = 'sure-quote/Occupations/GET';

const defaultState = 
{
    occupations:[]
}

const handleChange = (state, action) =>
{
    return(
        {
            ...state,
            occupations:JSON.parse(action.props.props.occupations)
        }
    )
}

const OccupationsReducer = (state = defaultState, action) => 
{
    switch (action.type) 
    {
        case GET:
            return handleChange(state, action);
        default:
            return state
    }
}

export const addOccupations = (props) => ({ type: GET, props })

export default OccupationsReducer;




// WEBPACK FOOTER //
// ./src/reducers/OccupationsReducer.js